import EditSettingProject from "../components/EditSettingProject";
import useEditSettingProject from "../hooks/useEditSettingProject";

const EditSettingProjectPage = () => {
    const useEditSettingProjectProps = useEditSettingProject();

    return <EditSettingProject {...useEditSettingProjectProps} />
}

export default EditSettingProjectPage;